<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :no-padding="true"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>业绩详情</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          style="padding: 10px 10px 0;">
        <template #filter-group>
          <app-filter-group
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-charger-select
                v-model="filter.chargeIds"
                collapse-tags
                placeholder="全部负责人"
                style="width: 150px"
              >
              </gj-charger-select>
              <gj-select
                :options="financeCurrencysOptionMap"
                placeholder="币种"
                v-model="filter.currency"
                :clearable="false"
              ></gj-select>
              <gj-date-picker
                type="monthrange"
                v-model="filter.date"
                :clearable="false"
                :shortcuts="['本月', '上月']"
              ></gj-date-picker>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              name="performance-report"
              show-summary :summary-object="pageData.summary"
              :loading="loading"
              :data="tableData"
              :columns="columnsMap"
              :offset-height="70"
              @sort-change="$gjSortChange">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import { financeCurrencysOption } from "@/utils/options";
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import { convertToFullDate } from "@/utils/date.util.js";
  import { getChargePerformanceMonthReportList } from "@/api/finance";
  
  export default {
    name: "app-child-product-add-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      columns: {},
      hideSkuList: {
        type: Array,
        default: () => []
      },
      filterMap: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        pageData: {},
        filter: {}
      }
    },
    methods: {
      // 初始化,重置
      $gjQueryInitParams() {
        return {
          filter: {
            date: this.filterMap.date,
            chargeIds: this.filterMap.chargeIds,
            currency: this.filterMap.currency || "CNY",
          }
        };
      },
      // 搜索
      $gjQuery() {
        // 构造查询参数
        this.loading = true;
        const params = {
          chargeIds: this.filter.chargeIds, // 负责人
          currency: this.filter.currency, // 币种
          startTime: null, // 开始时间
          endTime: null, // 结束时间
        }
        params.startTime = convertToFullDate( this.filter.date[0], "yyyy-MM") + "-01";
        params.endTime = convertToFullDate( this.filter.date[1], "yyyy-MM") + "-01";
        this.globalParams = params;
        this.getChargePerformanceMonthReportList(params);
      },
      // 查询list数据
      async getChargePerformanceMonthReportList(params) {
        this.loading = true;
        try {
          let res = await getChargePerformanceMonthReportList(params);
          this.pageData = res || {}
          this.tableData = res.chargeReportResultVOList || [];
          this.pagination.total = this.tableData.length
        } finally {
          this.loading = false;
        }
      },
      confirm() {
        this.$gjDestroy();
      }
    },
    computed: {
      // 币种
      financeCurrencysOptionMap() {
        let financeCurrencysOptionMap = this._.cloneDeep(financeCurrencysOption)
        financeCurrencysOptionMap.shift()
        return financeCurrencysOptionMap
      },
      columnsMap() {
        return this.columns.filter(item => item.columnsInclude.includes('details') )
      }
    }
  }
</script>

<style scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
</style>
